import React, { useState } from "react";
import "./Footer.scss";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import { validate } from "react-email-validator";
import { motion, AnimatePresence } from "framer-motion";
import disableScroll from "disable-scroll";

const Footer = ({ overlay, setOverlay, setEmailInvalid }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  console.log(overlay);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formError, setFormError] = useState(false);
  // const [emailInvalid, setEmailInvalid] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    if (name.length !== 0 && email.length !== 0 && message.length !== 0) {
      if (validate(email)) {
        e.preventDefault();
        setLoading(true);

        const contact = {
          _type: "contact",
          name: name,
          email: email,
          message: message,
        };

        client.create(contact).then(() => {
          setLoading(false);
          setIsFormSubmitted(true);
        });
      } else {
        // disableScroll.on();
        setEmailInvalid(true);
        setOverlay(true);
      }
    } else {
      // disableScroll.on();
      setFormError(true);
      setOverlay(true);
    }
  };

  // const closeModal = () => {
  //   disableScroll.off();
  //   setFormError(false);
  //   setEmailInvalid(false);
  // };

  return (
    <>
      <h2 className="head-text">Take a coffee &amp; chat with me</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a
            href="mailto:cdinata6@gmail.com"
            target="_blank"
            className="p-text"
          >
            cdinata6@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a
            href="https://wa.me/+6282177800200"
            target="_blank"
            className="p-text"
          >
            +62 821-7780-0200
          </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text:"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <textarea
              className="p-text"
              placeholder="Your Message"
              name="message"
              value={message}
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>
            {loading ? "Sending" : "Send Message"}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch</h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__primarybg"
);
